module.exports = __webpack_public_path__ + "static/paquete-2-25d37e46b183d9174486edde5ee5b5c7.svg";